import Hero from "../components/Hero";
import HeroImage from "../../assets/images/LifeInsurance1.jpg";
import lifeInsuranceAndProtectionInformationImage from "../../assets/images/LifeInsurance2.jpg";
import Accordion from "../designSystem/Accordion";

const LifeInsuranceAndProtectionInformationPage = () => {
  return (
    <div className="home-page">
      <Hero
        title="Life Insurance and Protection Information"
        titleAlign="center"
        backgroundImage={HeroImage}
        rightImage={HeroImage}
        subtitleAlign="center"
        lightOverlay={true}
      />
      <section className="grey-container">
        <div className="grey-container-content">
          <div className="row">
            <div className="content-column">
              <h2 className="burgandy align-left">
                Life Insurance & Protection
              </h2>
              <div className="divider burgandy align-left" />
              <div className="content grey align-left">
                Life insurance and protection products are designed to provide
                financial support for your loved ones if you die, become
                seriously ill, or are unable to work. They help cover essential
                costs such as mortgages, bills, and everyday living expenses.
              </div>
            </div>
            <img
              src={lifeInsuranceAndProtectionInformationImage}
              alt="WPP Financial Services Building"
              className="image-container"
            />
          </div>
        </div>
      </section>
      <section className="white-container">
        <div className="white-container-content">
          <div className="column">
            <h2 className="burgandy">Types of Protection</h2>
            <div className="divider burgandy" />
            <Accordion title="Life Insurance (Level Term Assurance)">
              Provides a lump sum payment if you die during the policy term.
              This is often used to help pay off a mortgage or support your
              family financially.
            </Accordion>
            <Accordion title="Critical Illness Cover">
              Pays out a tax-free lump sum if you are diagnosed with a specified
              serious illness. This can help cover living costs, debts, and loss
              of income while you recover.
            </Accordion>
            <Accordion title="Income Protection">
              Provides a regular monthly income if you are unable to work due to
              illness or injury. Payments continue until you return to work,
              retire, or the policy ends.
            </Accordion>
            <Accordion title="What to Consider">
              <div>
                <ul>
                  <li>Your family and dependents</li>
                  <li>Mortgage, debts, and monthly bills</li>
                  <li>Your income and ability to work</li>
                  <li>Any existing savings or financial backup</li>
                </ul>
                You can choose one or a combination of these products depending
                on your needs.
              </div>
            </Accordion>
            <Accordion title="At a Glance">
              <ul>
                <li>Life Insurance: Pays out on death (lump sum)</li>
                <li>Critical Illness: Pays out on diagnosis (lump sum)</li>
                <li>
                  Income Protection: Pays out if you can’t work (monthly income)
                </li>
              </ul>
            </Accordion>
            <Accordion title="Important Information">
              <ul>
                <li>
                  Trusts and tax planning are not regulated by the Financial
                  Conduct Authority
                </li>
                <li>Policies include terms, conditions, and exclusions</li>
              </ul>
            </Accordion>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LifeInsuranceAndProtectionInformationPage;
